import { rpcClient } from '@/api/rpc/client';
import type { FileExportSummary } from '@/api/file-exports/downloadFileExport';
import { useFileExport } from '@/api/file-exports/useFileExport';
import type {
  ExportDemandMatrixArgs,
  ExportForecastDetailInput,
  ExportReplenishmentSuggestionsArgs,
} from '@erp/rpc';

export type { FileExportSummary };

// Excel exports of the procurement screens (GEN-2683), each a file-export job.

export function useExportDemandMatrix() {
  return useFileExport((input: ExportDemandMatrixArgs) =>
    rpcClient.procurement.exports.demandMatrix(input),
  );
}

export function useExportForecastDetail() {
  return useFileExport((input: ExportForecastDetailInput) =>
    rpcClient.procurement.exports.forecastDetail(input),
  );
}

export function useExportReplenishmentSuggestions() {
  return useFileExport((input: ExportReplenishmentSuggestionsArgs) =>
    rpcClient.procurement.exports.replenishmentSuggestions(input),
  );
}
